module.exports = __webpack_public_path__ + "static/media/sass.084f0cf8.png";